import LocalUrlMaker from "../lib/LocalUrlMaker";
import {camelizeKeysDeep} from "../ReduxStore/Helpers/transformObject";
import {readCachedLocalStorage, writeCachedLocalStorage} from "../Session/cachedLocalStorage";
import {getParams} from "../lib/params";

const CACHE_KEY = 'pageTriggers';

/**
 * Fetch page triggers from local storage or the back-end.
 * Stash them in cachedLocalStorage.
 *
 *
 * @param callback
 * @returns {Promise<* | void>|Promise<unknown>}
 */
export function getPageTriggers({params} = {}) {
  params ||= getParams(params);

  const reset = !!params['RESET'];

  // if reset is true don't read from storage, fetch it
  const triggers = reset ? null : readPageTriggersFromStorage();
  if (triggers) {
    return new Promise((resolve, reject) => {
      resolve(triggers);
    });
  }

  const url = LocalUrlMaker.prefixedPath("/page_triggers.json");

  return fetch(url)
    .then(r => r.json())
    .then(data => normalizeAndStash(data))
    .catch(err => console.error(`error fetching ${url}: ${err}`));
}

function readPageTriggersFromStorage() {
  const data = readCachedLocalStorage(CACHE_KEY);

  return data?.pageTriggers;
}

function normalizeAndStash(data) {
  data = camelizeKeysDeep(data);
  writeCachedLocalStorage(CACHE_KEY, data,
    {expiresIn: 7200});

  return data.pageTriggers;
}
